<div class="resource-pane">

    <div class="recommendation" *ngIf="isRecommendation"><i class="fa fa fa-star"></i></div>

    <profile [userName]="resource?._id === unallocatedId ? $safeNavigationMigration(resource?._id) : $safeNavigationMigration(resource?.name)"></profile>

    <div class="info-detail">
        <span class="user-name">{{ resource?.name }}</span>
        <span class="user-type">{{ resource?.type }}</span>
        <span class="user-timezone" *ngIf="timezone">{{ timezone }}</span>
    </div>
</div>